import { create } from 'zustand';
import { Partner } from '../apis/models/partner/res/Partner';
import { persist } from 'zustand/middleware';
import { TreatmentCategoryDto } from '../apis/treatment-category';

interface AuthStore {
  customer?: { token: string; partnerCustomerId: number };
  partner?: Partner;
  setCustomer: (customer: { token: string; partnerCustomerId: number }) => void;
  clearCustomer: () => void;
  setPartner: (partner: Partner) => void;
  setTreatmentCategories: (treatmentCategories: TreatmentCategoryDto[]) => void;
  clear: () => void;
  setChannel: (channel: string) => void;
  channel?: string;
  treatmentCategories?: TreatmentCategoryDto[];
}

const initialData = {
  customer: undefined,
  partner: undefined,
  channel: undefined,
  treatmentCategories: undefined,
};

const useAuthStore = create<AuthStore>()(
  persist<AuthStore>(
    (set) => {
      return {
        ...initialData,
        setChannel: (channel: string) =>
          set((state) => ({
            ...state,
            channel,
          })),
        setCustomer: ({
          token,
          partnerCustomerId,
        }: {
          token: string;
          partnerCustomerId: number;
        }) =>
          set((state) => ({
            ...state,
            customer: {
              token,
              partnerCustomerId,
            },
          })),
        clearCustomer: () =>
          set((state) => ({
            ...state,
            customer: undefined,
          })),
        setPartner: (partner: Partner) =>
          set((state) => ({
            ...state,
            partner,
          })),
        setTreatmentCategories: (treatmentCategories: TreatmentCategoryDto[]) =>
          set((state) => ({
            ...state,
            treatmentCategories,
          })),
        clear: () =>
          set((state) => ({
            ...initialData,
          })),
      };
    },
    {
      name: 'MIMOWEB_AUTH_STORE',
    },
  ),
);
export default useAuthStore;
